<template>
  <div :id="content.id" class="container section">
    <div class="row">
      <div class="col-3">
        <img
          v-if="content.image"
          class="section-img"
          alt=""
          v-reveal
          :src="getImageUrl(content.image)"
        />
      </div>
      <div class="col-sm-center col-9">
        <h1 v-if="content.title" v-reveal>{{ content.title }}</h1>
        <h2 v-if="content.subTitle" v-reveal="60">{{ content.subTitle }}</h2>
        <section-content :content="content" />

        <div v-if="content.table" class="table-margin"></div>
        <table
          v-if="content.table"
          class="table cost-table table-bordered"
          v-reveal
        >
          <thead>
            <tr>
              <th
                v-for="(heading, index) in content.table.headers"
                :key="index"
              >
                {{ heading }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in content.table.rows" :key="index">
              <td :colspan="row.length === 1 ? 2 : 1">{{ row[0] }}</td>
              <td style="white-space: pre-line" v-if="row[1]">{{ row[1] }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import SectionContent from "./SectionContent.vue";

export default {
  props: {
    content: Object,
  },
  components: {
    "section-content": SectionContent,
  },
  methods: {
    getImageUrl(image) {
      return require("./../../assets/images/" + image);
    },
    isString(value) {
      return typeof value === "string" || value instanceof String;
    },
    isList(value) {
      return Object.prototype.toString.call(value) === "[object Array]";
    },
  },
};
</script>

<style lang="scss">
@import "./../../variables.scss";

.table-margin {
  margin-top: $space-6;
}

.section-img {
  display: block;
  margin: $space-6 auto 0;
  width: 200px;
  height: 200px;
  object-fit: cover;
  border-radius: 50%;
  border: 2px solid $primary;
}

@media only screen and (max-width: 1000px) {
  .col-sm-center {
    text-align: center;
  }
  .section-img {
    width: 150px;
    height: 150px;
    margin-top: 0;
  }
}
</style>
